import React, { JSX, useContext,  useState } from "react";

type ModalContext = {
    setModal: (title: string, component: JSX.Element) => void;
    closeModal: () => void;
}

const modalContext = React.createContext<ModalContext>({} as ModalContext);

const ModalProvider = ({ children }: { children: React.ReactNode }) => {
    const [modal, setModal] = useState<JSX.Element | null>(null);
    const [title, setTitle] = useState<string>("");

    const closeModal = () => {
        setModal(null);
        setTitle("");
    }

    return (
        <modalContext.Provider value={{setModal: (title: string, component: JSX.Element) => {setModal(component); setTitle(title)}, closeModal}}>
            {modal ? 
                <div style={{position: "fixed", zIndex: 999999, width: "100vw", height: "100vh", top: 0, left: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <div style={{width: 500, height: 560, backgroundColor: "var(--modal-color)", borderRadius: 2, padding: 20, overflowY: "hidden",}}>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 60}}>
                            <h2>{title}</h2>
                            <div className="inline_btn" onClick={closeModal}><i style={{fontSize: 18}} className="fa-solid fa-times" /></div>
                        </div>
                        <div style={{overflowY: "scroll", height: 500}}>
                            {modal}
                        </div>
                    </div> 
                </div>
                
            : null}
            {children}
        </modalContext.Provider>
    );   
}

const useModal = () => useContext(modalContext);
export { ModalProvider, useModal };